export default __webpack_public_path__ + "static/media/4.aefd9a2c.jpg";